import { FirmCard } from '@/components/home/FirmCard'

/* The proposition: what changes in the firm, and what stays. */
export const PropositionSection = () => (
  <section id="model" className="x-prop" aria-labelledby="prop-title">
    <div className="x-wrap x-prop2">
      <div className="x-prop2-text">
        <p className="x-eyebrow x-eyebrow--ink">What United does</p>
        <h2 id="prop-title" className="x-prop-h2">
          We buy into your firm and transform how it produces.
        </h2>
        <p className="x-prop-body">
          We don’t sell you software and we don’t buy you to consolidate you.{' '}
          <strong>You keep running it, keep your name and keep your clients.</strong>
        </p>
      </div>
      <FirmCard />
    </div>
  </section>
)
